module.exports = __webpack_public_path__ + "img/error.78fde3dd.jpg";